import {
  ADD_CHILD,
  ADD_STRUCTURE_ASCENDANT_AS_CHILD,
  CREATE_DESTINATION_STRUCTURE,
  CREATE_ENTITY,
  FAIL,
  FETCH_EXIT_URL,
  FETCH_INPUT_TYPES,
  FETCH_PAGE_FILES,
  FETCH_USER,
  MOVE_NODE_NEW,
  PAGE_VALIDATION_ERROR,
  PAGE_VALIDATION_ERROR_RESET,
  SAVE_PAGE,
  SUCCESS,
  TOGGLE_HIGHLIGHT,
  TOGGLE_SETTINGS,
} from 'client/actionTypes'
import { Reducer } from 'redux'
import undoable, { excludeAction } from 'redux-undo'
import { REDUX_LOGGING_ACTIONS_TYPES } from 'src/editor/store/redux-logging/redux-logging-action-types'
import { reduxLoggingReducer } from 'src/editor/store/redux-logging/redux-logging-reducer'
import { websitePagesReducer } from 'src/editor/store/website-pages/website-pages-reducer'
import { websiteSettingsReducer } from 'src/editor/store/website-settings/website-settings-reducer'
import automationRulesReducer from '../store/automationRules/automationRulesReducer'
import blocks from './blocksReducer'
import filesReducer from './filesReducer'
import inputTypesReducer from './inputTypesReducer'
import managementReducer from './managementReducer'
import { pageReducer } from './pageReducer'
import payment from './paymentReducer'

const excludedActions = [
  FETCH_PAGE_FILES,
  FETCH_INPUT_TYPES + SUCCESS,
  FETCH_USER + SUCCESS,
  FETCH_EXIT_URL,
  TOGGLE_SETTINGS,
  TOGGLE_HIGHLIGHT,
  SAVE_PAGE,
  SAVE_PAGE + FAIL,
  PAGE_VALIDATION_ERROR,
  PAGE_VALIDATION_ERROR_RESET,
  ...REDUX_LOGGING_ACTIONS_TYPES,
]

const copyActions = [CREATE_ENTITY, ADD_CHILD]
const moveActions = [
  CREATE_DESTINATION_STRUCTURE,
  ADD_STRUCTURE_ASCENDANT_AS_CHILD,
  MOVE_NODE_NEW,
]

export const reducers = {
  page: undoable(pageReducer, {
    filter: excludeAction(excludedActions),
    groupBy: ({ type }) => {
      if (copyActions.includes(type)) {
        return 'copy'
      } else if (moveActions.includes(type)) {
        return 'move'
      }

      return null
    },
    limit: 10,
    debug: process.env.NODE_ENV !== 'production',
  }),
  inputTypes: inputTypesReducer,
  files: filesReducer,
  management: managementReducer,
  payment,
  blocks,
  automationRules: automationRulesReducer,
  websiteSettings: websiteSettingsReducer,
  websitePages: websitePagesReducer,
  reduxLogging: reduxLoggingReducer as unknown as Reducer,
}
